/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiWebhookRequest,
    ApiWebhookRequestFromJSON,
    ApiWebhookRequestToJSON,
    ApiWebhookRequestsPage,
    ApiWebhookRequestsPageFromJSON,
    ApiWebhookRequestsPageToJSON,
} from '../models';

export interface FindWebhookRequestsRequest {
    page: number;
    size: number;
}

export interface RetryWebhookRequestRequest {
    webhookRequestId: number;
}

/**
 * 
 */
export class WebhookRequestApi extends runtime.BaseAPI {

    /**
     * Fetch all webhook requests
     */
    async findWebhookRequestsRaw(requestParameters: FindWebhookRequestsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiWebhookRequestsPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findWebhookRequests.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findWebhookRequests.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/webhook-requests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiWebhookRequestsPageFromJSON(jsonValue));
    }

    /**
     * Fetch all webhook requests
     */
    async findWebhookRequests(requestParameters: FindWebhookRequestsRequest, initOverrides?: RequestInit): Promise<ApiWebhookRequestsPage> {
        const response = await this.findWebhookRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Schedules a new webhook request, based on the old one. Does not block until it\'s finished.
     */
    async retryWebhookRequestRaw(requestParameters: RetryWebhookRequestRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiWebhookRequest>> {
        if (requestParameters.webhookRequestId === null || requestParameters.webhookRequestId === undefined) {
            throw new runtime.RequiredError('webhookRequestId','Required parameter requestParameters.webhookRequestId was null or undefined when calling retryWebhookRequest.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/webhook-requests/{webhookRequestId}`.replace(`{${"webhookRequestId"}}`, encodeURIComponent(String(requestParameters.webhookRequestId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiWebhookRequestFromJSON(jsonValue));
    }

    /**
     * Schedules a new webhook request, based on the old one. Does not block until it\'s finished.
     */
    async retryWebhookRequest(requestParameters: RetryWebhookRequestRequest, initOverrides?: RequestInit): Promise<ApiWebhookRequest> {
        const response = await this.retryWebhookRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
